import { has, get } from 'lodash'
import { reportRaptorMetrics } from '@Common/SLRaptor'
import { MONITOR_VALUE } from '@/common/constant'
// import Raptor from '@/common/utils/raptor'

const Router = Mach.requireModule('Router')

// 跳转类型
enum RouterType {
  TO = 'to',
  BACK = 'back',
}

// 错误类型
type ErrorInfoVo = {
  code: number // 错误码
  message: string // 错误描述
}

// url拼接参数
const buildURL = (url: string, query: Record<string, unknown>) => {
  if (!url) return ''
  if (query && JSON.stringify(query) !== '{}') {
    let queryArr = []
    for (const key in query) {
      if (has(query, key)) {
        queryArr.push(`${key}=${query[key]}`)
      }
    }
    if (url.indexOf('?') !== -1) {
      url = `${url}&${queryArr.join('&')}`
    } else {
      url = `${url}?${queryArr.join('&')}`
    }
  }
  return url
}

// 判断是否是JSON
const isJSON = (str: string) => {
  try {
    const obj = JSON.parse(str)
    return obj
  } catch (error) {
    return null
  }
}

/**
 * 页面跳转方法，支持H5、machPro跳转，支持回到上一个页面 https://km.sankuai.com/collabpage/1503158915
 * @param type 类型，默认是跳转
 * @param urlInfo 跳转url
 * @param commonParam 是否携带通参，默认是不携带
 * @param customParam 自定义数据，object 类型，在Android端把些参数放置至bundle传递到下一个页面
 * @param onSuccess 成功函数
 * @param onError 失败函数
 */
const jumpTo = ({
  type = RouterType.TO,
  urlInfo,
  commonParam,
  customParam = {},
  onSuccess,
  onError,
}: {
  type?: RouterType
  urlInfo?: {
    url: string // url前缀
    query?: Record<string, unknown> // query参数
  }
  commonParam?: boolean
  customParam?: object
  onSuccess?: () => void
  onError?: (error: ErrorInfoVo) => void
}) => {
  if (type === RouterType.TO) {
    const urlQuery = urlInfo?.query || {}
    if (commonParam) urlQuery.appendParam = 1
    const realUrl = buildURL(urlInfo!.url, urlQuery)
    if (!realUrl) {
      console.error('url为空')
      throw new Error('url为空')
    }
    Router.navigateTo(realUrl, customParam, (result: { error: ErrorInfoVo; success: boolean }) => {
      if (result.success) onSuccess && onSuccess()
      else {
        onError && onError(result.error)
      }
      // Raptor成功率上报
      reportRaptorMetrics(
        {
          jumpToSuccessRate: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
        },
        {
          status: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
          type: RouterType.TO,
          url: realUrl,
          urlType: /^(http|https):\/\//.test(realUrl) ? 'h5' : 'machPro',
          toBundle: get(urlInfo?.query, 'mach_bundle_name') ? JSON.stringify(get(urlInfo?.query, 'mach_bundle_name')) : '',
        },
      )
      // Raptor.reportMetrics({
      //   values: {
      //     jumpToSuccessRate: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
      //   },
      //   tags: {
      //     status: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
      //     type: RouterType.TO,
      //     url: realUrl,
      //     urlType: /^(http|https):\/\//.test(realUrl) ? 'h5' : 'machPro',
      //     toBundle: get(urlInfo?.query, 'mach_bundle_name') ? JSON.stringify(get(urlInfo?.query, 'mach_bundle_name')) : '',
      //   },
      // })
    })
  } else if (type === RouterType.BACK) {
    if (Mach.env.isIOS) {
      Router.navigateBack((result: { error: ErrorInfoVo; success: boolean }) => {
        if (result.success) onSuccess && onSuccess()
        else {
          onError && onError(result.error)
        }
        // Raptor成功率上报
        reportRaptorMetrics(
          {
            jumpBackSuccessRate: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
          },
          {
            status: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
            type: RouterType.BACK,
          },
        )
        // Raptor.reportMetrics({
        //   values: {
        //     jumpBackSuccessRate: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
        //   },
        //   tags: {
        //     status: result.success ? MONITOR_VALUE.SUCCESS : MONITOR_VALUE.FAILED,
        //     type: RouterType.BACK,
        //   },
        // })
      })
    } else {
      Router.navigateBack()
    }
  }
}

// 跳转前对象类型参数转义
const encodeParams = (params: object) => encodeURIComponent(JSON.stringify(params))
// 获取参数
const getParams = (key: string) => {
  try {
    const params = Mach.env.schemeParams[key]
    const data = isJSON(params)
    return data || params
  } catch (error) {
    return ''
  }
}

export { jumpTo, RouterType, encodeParams, getParams, isJSON }
